import { render, staticRenderFns } from "./Scribbles.vue?vue&type=template&id=03a7bd6e&"
import script from "./Scribbles.vue?vue&type=script&lang=js&"
export * from "./Scribbles.vue?vue&type=script&lang=js&"
import style0 from "./Scribbles.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports